function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M73.678,25.226H4.769c-0.837,0-1.636,0.349-2.203,0.963s-0.854,1.437-0.788,2.271l5.375,68.794 c0.122,1.562,1.425,2.767,2.991,2.767h58.159c1.565,0,2.868-1.205,2.99-2.767l5.375-68.794c0.065-0.834-0.221-1.657-0.788-2.271 C75.312,25.574,74.514,25.226,73.678,25.226 M65.527,94.021H12.918L8.012,31.226h62.422L65.527,94.021z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M75.783,17.182l-21.815-2.475C54.037,7.34,48.511,0.943,41.034,0.095c-3.869-0.44-7.679,0.654-10.726,3.08 c-2.646,2.108-4.439,5.002-5.154,8.263L3.339,8.962C1.695,8.776,0.207,9.958,0.02,11.604c-0.187,1.646,0.996,3.133,2.643,3.319 l72.444,8.22c0.115,0.014,0.229,0.02,0.343,0.02c1.505,0,2.803-1.131,2.977-2.662C78.613,18.855,77.43,17.369,75.783,17.182  M34.046,7.869c1.793-1.427,4.034-2.073,6.311-1.812c4.186,0.474,7.323,3.903,7.586,7.966L31.176,12.12 C31.671,10.453,32.656,8.976,34.046,7.869"
});

var SvgElimina = function SvgElimina(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 80,
    height: 101,
    viewBox: "-0.684 -0.054 80 101",
    enableBackground: "new -0.684 -0.054 80 101",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgElimina, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/elimina.1be55598.svg";
export { ForwardRef as ReactComponent };